import Close from 'components/shared/close';
import styles from './selectedFilters.module.scss';

const SelectedFilters = ({ resources, useFilterObject }) => {
  const { filterState, removeFilter, clearFilters } = useFilterObject;

  return (
    <>
      {filterState.selectedFilters.length > 0 && (
        <div className={styles.selectedFiltersSection}>
          {filterState.selectedFilters.map(filter => (
            <div className={styles.filter} key={`selectedFilter${filter.id}${filter.value}`}>
              <button
                type="button"
                onClick={() => {
                  removeFilter(filter);
                }}
              >
                <Close />
              </button>
              <span className={styles.filterValue}>{filter.value}</span>
            </div>
          ))}
          <button
            type="button"
            className={styles.clearFilters}
            onClick={() => {
              clearFilters();
            }}
          >
            {resources.clearFilters.text}
          </button>
        </div>
      )}
    </>
  );
};

export default SelectedFilters;
